import React, { Component } from 'react'
import styled from 'styled-components'
import { Select } from 'advenio-components'
import { Form } from 'formsy-react' //eslint-disable-line
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import {
  clone,
  findIndex,
  path,
  propEq,
} from 'ramda'

import OriginalLoadingSpinner from '../LoadingSpinner'
import ProfileHeader from '../../Components/ProfileHeader'

import ContractsActions from '../../Data/Redux/ContractsRedux'
import ClassroomActions from '../../Data/Redux/ClassroomRedux'
import {HOURS_LIMIT} from '../../Constants'
import { userHasRole } from '../../utils/Utils'
const ContractsContainer = styled.div`
  padding: 8px;
`
const ContractRow = styled.div`
  display: flex;
  width: 100%;
`
const InputContainerLarge = styled.div`
  flex: 2;
  margin: 0 8px;
`
const InputContainerSmall = styled.div`
  flex: 1;
  margin: 0 8px;
`
const LoadingSpinner = () => <OriginalLoadingSpinner containerHeight={120} size={25} />

const generateProductOptions = (products, type = 'contract') => {
  if (type === 'contract') {
    return products.map(product => ({
      id: product.contract_product_id,
      label: product.product,
      value: product.contract_product_id,
    }))
  }

  return products.map(product => ({
    id: product.id,
    label: product.name,
    value: product.id,
  }))
}

class Contracts extends Component {
  state = {
    selectedContractId: 0,
    selectedParentId: 0,
    selectedProductId: 0,
    parentOptions: [],
    contracts: [],
    products: [],
    productType: null,
    showHours:false,
    hours:HOURS_LIMIT,
    productLimit:0
  }

  componentWillMount = () => {
    const {
      student,
    } = this.props
    if (!student.parents) return

    // const productLimit = this.props.centerProducts.find((product) => product.product === 'Daycare Limit')
    const showHours = student.product.product_details.product_id === 16 && student.product.type.includes('CenterProduct');
    const products = [{ label: 'Seleccione', value: 0, id: 0 }];
    const parentOptions = student.parents.map((parent) => {
      const fullName = `${parent.first_name} ${parent.last_name_paternal}`
      const selectedParentId = parent.userable_id || parent.id

      return ({
        id: selectedParentId,
        label: fullName,
        value: selectedParentId,
      })
    })

    // PADRE POR DEFECTO
    const foundParent = student.parents
      .find(parent => parent.id === student.paying_parent_id
        || parent.userable_id === student.paying_parent_id)
    let productType
    let selectedParentId
    let selectedContractId
    let selectedProductId

    if (foundParent) {
      selectedParentId = foundParent.userable_id || foundParent.id
    } else if (student.parents.length > 0) {
      selectedParentId = student.parents[0].userable_id || student.parents[0].id
    }

    if (student.contract_product) {
      selectedContractId = student.product.contract_id
      selectedProductId = student.product.id
      productType = 'contract'
    } else {
      productType = 'center'
    }
    const companyId = student.product.contract ? student.product.contract.company_id : 0
    const parentid = student.parents_with_contracts[companyId] || Object.values(student.parents_with_contracts)[0]
    this.setState({
      selectedParentId,
      selectedContractId,
      selectedProductId,
      parentOptions,
      contracts: [],
      products,
      productType,
      // productLimit:productLimit.id,
      // showHours,
    })
    this.onTutorChange({"target":{"value":parentid}},'parent')
  }

  componentDidMount = () => {
    const {
      selectedParentId,
    } = this.state

    if (selectedParentId) {
      this.props.getAvailableContractsForParent(selectedParentId)
    }
  }

  componentWillReceiveProps = (nextProps) => {
    if (!nextProps.loading && this.props.student.parents) {
      const {
        centerProducts,
        contracts,
        student,
        error,
      } = nextProps
      const studentProduct = student.product
      const contractOptions = [{
        id: 0,
        label: 'Sin Convenio',
        value: 0,
      }]

      if (!studentProduct) {
        // Display error
      }

      let productType = 'center'
      let productsForProductOptions = centerProducts
      let selectedContractId = 0
      let selectedProductId = studentProduct.id

      if (contracts.length > 0) {
        contractOptions.push(...contracts.map(contract => ({
          id: contract.id,
          label: contract.name,
          value: contract.id,
        })))
      }
      if (studentProduct.type === 'ContractProduct' && !error) {
        let product
        const foundContract = contracts
        .find(contract => contract.id === student.product.contract_id)

        // Si se llego hasta este punto y el contrato sigue siendo indefinido
        // quiere decir que el niño tiene un contrato inexistente
        if (foundContract) {
          // Si se tiene un contrato asignado, se obtienen los productos
          product = foundContract.products.find(p => p.contract_product_id === student.product.id)
          productsForProductOptions = foundContract.products
          selectedContractId = foundContract.id
        }
        productType = 'contract'
        productsForProductOptions = foundContract=== undefined ?  contracts.filter(c=> c.products.length > 0 )[0].products : contracts.find(c=> c.id === student.product.contract_id).products
        selectedProductId = product ? product.contract_product_id : 0
      }

      return this.setState({
        contracts: contractOptions,
        products: generateProductOptions(productsForProductOptions, productType),
        selectedContractId,
        selectedProductId,
        productType,
      })
    }
  }

  changeModal = ( value, typeChange) => {
    const {
      selectedContractId,
      selectedParentId,
    } = this.state
    const {
      centerProducts,
      contracts,
      getAvailableContractsForParent,
      student,
    } = this.props

    // Changed selected parent
    if (value !== selectedParentId && typeChange ==='parent') {
      return getAvailableContractsForParent(value)
    }

    // Changed selected contract
    if (value !== selectedContractId && typeChange === 'contract') {

      const newlySelectedContract = contracts.find(contract => contract.id === value)
      const newlySelectedProduct = centerProducts.find(product => product.id === student.product.id)
      let newlySelectedProductId = newlySelectedProduct ? newlySelectedProduct.id : null
      let newProducts = generateProductOptions(centerProducts, 'center')
      let productType = 'center'

      if (newlySelectedContract !== undefined) {
        newProducts = generateProductOptions(newlySelectedContract.products, 'contract')
        newlySelectedProductId = newProducts[0].id
        productType = 'contract'
      }

      return this.setState({
        products: newProducts,
        selectedProductId: newlySelectedProductId,
        productType,
      })
    }
  }

  onTutorChange = ({target:{value}},type) => {
    // if (formData.contractId !== undefined && formData.productId !== undefined) {
    //   if(Number(formData.contractId) !== this.state.selectedContractId){
    //     value = Number(formData.contractId)
    //     typeChange = 'contratChange'
    //   }
    //   if(Number(formData.parentId) !== this.state.selectedParentId){
    //     value = Number(formData.parentId)
    //     typeChange = 'parentChange'
    //   }
      // this.setState({
      //   selectedContractId: Number(formData.contractId):
      //   selectedParentId: Number(formData.parentId),
      //   selectedProductId: Number(formData.productId),
      // })
      type === 'contract' ? this.setState({selectedContractId:value}):this.setState({selectedParentId:value})
      this.changeModal(Number(value) ,type)
    // }
  }
  // handleChange = (value) => {
  //   const {productLimit} = this.state;
  //   Number(value) === productLimit ? this.setState({showHours:true}) : this.setState({showHours:false});
  // }
  // toChangeContract = () =>  this.setState({showHours:false});

  onSubmit = (data) => {
    const {
      student,
    } = this.props
    const attr = this.state.productType === 'center' ? 'center_product_id' : 'contract_product_id'
    const productToSend = {}
    productToSend[attr] = data.productId
    if(data.hours_limit) productToSend['hours_limit'] = Number(data.hours_limit)
    this.props.updateStudent(
      student.id,
      productToSend,
      student.updated_at,
    )
  }

  renderContracts = () => {
    const {
      error,
      isDisenrolled,
      student,
      teacher,
      user,
      loading,
    } = this.props
    const {
      showHours,
      hours,
      hour,
      contracts,
      parentOptions,
      products,
      selectedContractId,
      selectedParentId,
      selectedProductId,
    } = this.state

    if (!student.parents&&loading) {
      return <LoadingSpinner />
    }

    return (
      <Form
        // onChange={this.onTutorChange}
        onSubmit={this.onSubmit}
      >
        <ProfileHeader
          header="Convenios"
          submit
          disabled={ userHasRole(user,['Back Office Admin']) ? false : (teacher || Boolean(isDisenrolled) /*|| student.checkin.id !== null*/)}
        />
        <ContractRow>
          <InputContainerSmall>
            <Select
              name="parentId"
              label="Tutor del convenio"
              required
              value={selectedParentId && selectedParentId}
              onChangeCallback={(e) => {this.onTutorChange(e,'parent')}}
              options={parentOptions}
              disabled={ userHasRole(user,['Back Office Admin']) ? false : (teacher || Boolean(isDisenrolled) /*|| student.checkin.id !== null*/)}
            />
          </InputContainerSmall>
          <InputContainerLarge>
            <Select
              name="contractId"
              label="Convenio"
              required={contracts.length > 0}
              options={contracts.length > 0 ? contracts : [{ label: 'Sin Convenio', value: 0, id: 0 }]}
              onChangeCallback={(e) => {this.onTutorChange(e,'contract')}}
              value={selectedContractId}
              disabled={ userHasRole(user,['Back Office Admin']) ? false : (teacher || Boolean(isDisenrolled) || !!error /*|| student.checkin.id !== null*/)}
            />
          </InputContainerLarge>
          <InputContainerSmall>
            {products.length > 0 ? <Select
              name="productId"
              label="Tipo de Servicio"
              required
              fullWidth
              // onChangeCallback={(e) => { this.handleChange(e.currentTarget.value) }}
              options={products }
              value={selectedProductId}
              disabled={ userHasRole(user,['Back Office Admin']) ? false : (teacher || Boolean(isDisenrolled) /*|| student.checkin.id !== null*/)}
            /> : null}
          </InputContainerSmall>
          {/* {showHours &&
          <InputContainerSmall>
            <Select
              name="hours_limit"
              label="Limite de Horas"
              required
              fullWidth
              hideEmptyHelpBlock
              options={hours}
              value={hour}
              disabled={teacher || Boolean(isDisenrolled)}
            />
          </InputContainerSmall>} */}
        </ContractRow>
      </Form>
    )
  }

  render() {
    if (this.props.loading && this.state.products.length === 0) {
      return <LoadingSpinner />
    }

    return (
      <ContractsContainer>
        {this.renderContracts()}
      </ContractsContainer>
    )
  }
}

Contracts.propTypes = {
  /** The products (Adv 100, Adv 50 etc.) available at the current center */
  centerProducts: PropTypes.array,
  contracts: PropTypes.array,
  error: PropTypes.number,
  isDisenrolled: PropTypes.bool,
  loading: PropTypes.bool,
  student: PropTypes.object.isRequired,
  teacher: PropTypes.bool,

  /** Fetch the available selectedContractId products for the specified parent */
  getAvailableContractsForParent: PropTypes.func.isRequired,
  /** Attempt to update the specified student's selectedContractId */
  updateStudent: PropTypes.func.isRequired,
}

Contracts.defaultProps = {
  centerProducts: [],
  contracts: [],
  loading: false,
  isDisenrolled: false,
  teacher: false,
  error: null,
}

const mapStateToProps = ({ contracts, ...state }) => ({
  contracts: contracts.results,
  loading: contracts.fetching,
  error: path(['status'], contracts.errors),
  centerProducts: state.center_products.get.results,
  user: state.auth.user,

})

const mapDispatchToProps = dispatch => ({
  getAvailableContractsForParent: parentId =>
    dispatch(ContractsActions.getContractsRequest(parentId)),
  updateStudent: (activeParentId, profile, timestamp) =>
    dispatch(ClassroomActions.updateStudentRequest(activeParentId, profile, timestamp)),
})

export default connect(mapStateToProps, mapDispatchToProps)(Contracts)



// WEBPACK FOOTER //
// ./src/Components/ProfileViews/Contracts.jsx